<template>
  <SelectField
      :value="value"
      :name="name"
      :items="jobItems"
      @input="onInput"
  />
</template>

<script>
import SelectField from "@/components/atoms/SelectField";
import {mapGetters} from "vuex";
export default {
  name: "JobSelectField",
  components: {SelectField},
  props: {
    value: {
      type: Number
    },
    name: {
      type: String
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    jobItems () {
      return this.consts.currentJob
    }
  },
  methods: {
    onInput(value) {
      this.$emit("input", value)
    }
  }
}
</script>

<style scoped>

</style>